// extracted by mini-css-extract-plugin
export default {"root":"SettingsEditButton_root__A5rzh","rootIcon":"SettingsEditButton_rootIcon__0MK-d"};